import { NgModule } from '@angular/core';

import { PriceboxWithPointsComponent } from './pricebox-with-points/pricebox-with-points.component';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { EvaButtonModule } from '../eva-button/eva-button.module';
import { DualPromoModule } from './dual-promo/dual-promo.module';

@NgModule({
    imports: [CommonModule, TranslateModule, EvaButtonModule, DualPromoModule],
    exports: [PriceboxWithPointsComponent],
    declarations: [PriceboxWithPointsComponent],
    providers: [],
})
export class PriceboxModule { }
